import React from 'react';
import { Modal } from '../../../../Modal';
import { MaterialList } from '../../MaterialList/MaterialList';
import { UploadStatusModal } from '../UploadStatusModal/UploadStatusModal';
import { Button } from '../../../../Button';
import Link from '../../../../Typography/components/Link';
import { Input } from '../../../../Input';
import { Refresh, Search } from '@tencent/adp-icons-react';
import { Spin } from '../../../../Spin';
import { usePrefixCls } from '../../../../../config/hooks/usePrefixCls';
import { CREATIVE_MATERIAL_LIBRARY } from '../../common/const';
export var MaterialPanel = function MaterialPanel(props) {
  var show = props.show,
    panelStyleConfig = props.panelStyleConfig,
    onOk = props.onOk,
    onCancel = props.onCancel,
    isLoading = props.isLoading,
    _props$headerOps = props.headerOps,
    searchValue = _props$headerOps.searchValue,
    onSearchValueChange = _props$headerOps.onSearchValueChange,
    materialHint = _props$headerOps.materialHint,
    onRefresh = _props$headerOps.onRefresh,
    uploadLocalFile = _props$headerOps.uploadLocalFile,
    _props$listOps = props.listOps,
    dts = _props$listOps.dts,
    activeId = _props$listOps.activeId,
    setActiveId = _props$listOps.setActiveId,
    total = _props$listOps.total,
    currentPage = _props$listOps.currentPage,
    onPageChange = _props$listOps.onPageChange,
    materialType = props.materialType,
    children = props.children;
  var cls = usePrefixCls('material-library-panel');
  var headerCls = "".concat(cls, "-header");
  return React.createElement(React.Fragment, null, React.createElement(Modal, {
    show: show,
    onOk: onOk,
    bodyStyle: {
      width: (panelStyleConfig === null || panelStyleConfig === void 0 ? void 0 : panelStyleConfig.panelWidth) || 900
    },
    onCancel: onCancel,
    maskClosable: false,
    title: "\u9009\u62E9\u7D20\u6750"
  }, React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: headerCls
  }, React.createElement("div", {
    className: "".concat(headerCls, "-option")
  }, React.createElement("div", null, React.createElement(Button, {
    type: "primary",
    onClick: uploadLocalFile
  }, "\u672C\u5730\u4E0A\u4F20"), React.createElement(Link, {
    className: "".concat(headerCls, "-option-material-link"),
    target: "_blank",
    href: CREATIVE_MATERIAL_LIBRARY
  }, "\u524D\u5F80\u7D20\u6750\u5E93")), React.createElement(Input, {
    className: "".concat(headerCls, "-option-material-query"),
    prefix: React.createElement(Search, {
      className: "".concat(headerCls, "-option-input-icon"),
      size: 16
    }),
    placeholder: "\u8BF7\u8F93\u5165\u7D20\u6750\u540D\u79F0",
    value: searchValue,
    onValueChange: onSearchValueChange
  })), React.createElement("div", {
    className: "".concat(headerCls, "-reload-section")
  }, materialHint, React.createElement("i", {
    className: "".concat(headerCls, "-text-btn"),
    onClick: onRefresh
  }, React.createElement(Refresh, {
    size: 14,
    style: {
      marginRight: 6
    }
  }), "\u5237\u65B0"))), React.createElement("div", {
    className: "".concat(cls, "-list"),
    style: {
      minHeight: (panelStyleConfig === null || panelStyleConfig === void 0 ? void 0 : panelStyleConfig.panelHeight) || 514
    }
  }, React.createElement(Spin, {
    wrapperClassName: "".concat(cls, "-loading-wrapper"),
    className: "".concat(cls, "-loading"),
    spinning: isLoading
  }, React.createElement(MaterialList, {
    panelStyleConfig: panelStyleConfig,
    datasource: dts,
    activeId: activeId,
    onActiveChange: setActiveId,
    totalSize: total,
    pageValue: currentPage,
    onPageChange: onPageChange
  }))))), React.createElement(UploadStatusModal, {
    materialType: materialType
  }), children);
};